export default "__VITE_ASSET__f57cb877__"